import InputNoTypeaheadView from './InputNoTypeaheadView';
import './InputNoTypeahead.css';

export default InputNoTypeaheadView;
